export default {"src":"/_next/static/media/CreateProduct.1f17fba9.svg","height":22,"width":26,"blurWidth":0,"blurHeight":0};